import {
  Box,
  Flex,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import Logo from "./Logo";
import React from "react";
import { useNavigate } from "react-router-dom";
import { HamburgerIcon } from "@chakra-ui/icons";
import { trackCTA } from "../functions/analytics";

const LogoTitle = () => {
  return (
    <Flex alignItems="center" gap="8px">
      <Logo w={{ base: "60px", md: "100px" }} />
      <Box padding="4px" textAlign="center" cursor="pointer">
        <Text fontSize={{ base: "xl", md: "4xl" }} lineHeight="1.2">
          Raven - Support Network
        </Text>
        <Text
          fontSize="xs"
          fontFamily="Cardo"
          fontStyle="italic"
          marginTop="-4px"
        >
          #1 community for International Students and Newcomers in Canada
        </Text>
      </Box>
    </Flex>
  );
};

const HeaderVariant = ({ variant }) => {
  const navigate = useNavigate();
  if (variant === "landing") {
    return <LogoTitle />;
  } else {
    return (
      <Flex alignItems="center" onClick={() => navigate("/")}>
        <LogoTitle />
      </Flex>
    );
  }
};

const MainHeader = ({ variant }) => {
  const navigate = useNavigate();

  return (
    <Flex
      alignItems="center"
      fontFamily="EB Garamond"
      justifyContent={variant === "dashboard" ? "center" : "space-between"}
      w="100%"
      paddingLeft="12px"
      paddingRight="12px"
      paddingTop="8px"
      position="sticky"
      top="0"
      bg="white"
      zIndex="100"
      flex="0 0 auto"
    >
      <HeaderVariant variant={variant} />
      {variant !== "dashboard" ? (
        <Menu>
          <MenuButton
            as={IconButton}
            icon={<HamburgerIcon />}
            variant="outline"
            flexShrink={0}
          />
          <MenuList fontSize="md">
            <MenuItem onClick={() => { trackCTA("nav_contact"); navigate("/contact"); }}>Contact us</MenuItem>
            <MenuItem onClick={() => { trackCTA("nav_about"); navigate("/about"); }}>About us</MenuItem>
            {/* <MenuItem>
              <Button
                as="a"
                colorScheme="yellow"
                w="100%"
                onClick={() => navigate("/login")}
              >
                Login
              </Button>
            </MenuItem> */}
          </MenuList>
        </Menu>
      ) : null}
    </Flex>
  );
};

export default MainHeader;
